import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { SearchBox } from '@mapbox/search-js-react';
import { MAPBOX_API_KEY } from '../../utils/config';
// eslint-disable-next-line import/no-unresolved
import Map from 'react-map-gl/mapbox';
import DeckGL from '@deck.gl/react';
import { useEffect, useState } from 'react';
import { IconLayer } from '@deck.gl/layers';
import httpClient from '../../utils/httpClient';

const RecoveryMap = ({ showRecoveryMap, setShowRecoveryMap, selectedAddress, setSelectedAddress, selectedLocation, setSelectedLocation }) => {

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [viewState, setViewState] = useState({
    longitude: -0.1278,
    latitude: 51.5074,
    zoom: 10,
    pitch: 0,
    bearing: 0,
  });
  const [localAddress, setLocalAddress] = useState('');
  const [localLocation, setLocalLocation] = useState({lng: -0.118092, lat: 51.509865});

  const pin = [{
    iconUrl: `/images/markers/task1.png`,
    position: [localLocation.lng, localLocation.lat]
  }];

  useEffect(() => {
    if (selectedLocation && selectedLocation.lat) {
      setLocalLocation(selectedLocation);
    }
  }, [selectedLocation]);

  useEffect(() => {
    if(selectedAddress) {
      setLocalAddress(selectedAddress);
    }
    if(selectedLocation?.lat) {
      setLocalLocation(selectedLocation);
    }
    setViewState({
      ...viewState,
      longitude: localLocation.lng,
      latitude: localLocation.lat,
      zoom: 7,
    });
  }, []);

  const pinLayer = new IconLayer({
    id: `icon-layer`,
    data: pin,
    pickable: true,
    getIcon: (d) => ({ url: d.iconUrl, width: 32, height: 32 }),
    sizeScale: 1,
    getPosition: d => d.position,
    getSize: () => {
      return 32;
    },
    getColor: () => [255, 0, 0],
  });

  const handleSelectLocation = () => {
    setSelectedAddress(localAddress);
    setSelectedLocation(localLocation);
    setShowRecoveryMap(false);
  }

  const handleSearchResults = (res) => {
    setLocalAddress(res.features[0].properties.full_address);
    const [lng, lat] = res.features[0].geometry.coordinates;
    setLocalLocation({
      lng, lat
    });
    setViewState(prev => ({ ...prev, longitude: lng, latitude: lat, zoom: 14 }));
  }

  const handleMapClick = async (info) => {
    const [lng, lat] = info.coordinate;
    setLocalLocation({
      lng, lat
    });

    const result = await httpClient(`https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${MAPBOX_API_KEY}`);
    const features = result.data.features;
    if(features.length){
      const address = features[0].place_name;
      setLocalAddress(address);
    }
  }

  return <>
    <Dialog
      fullScreen={fullScreen}
      open={showRecoveryMap}
      //onClose={handleCloseMapChooser}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        {"Search for a recovery location"}
      </DialogTitle>
      <DialogContent>
        <Box style={{ height: "700px", width: "100%", position: "relative" }}>
          <Box
            sx={{
              display: "flex",
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '6px 6px 0 0',
              bgcolor: 'background.paper',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: 1, sm: 2 },
              padding: { xs: '10px', sm: '20px' }
            }}

          >
            <Box sx={{ pointerEvents: 'auto', position: 'absolute', top: 10, left: 10, zIndex: 10, width: '95%', background: 'white', p: 1, borderRadius: 1, boxShadow: 3 }}>
              <SearchBox
                sx={{ width: '100%' }}
                value={localAddress}
                accessToken={MAPBOX_API_KEY}
                onRetrieve={(res) => {
                  handleSearchResults(res);
                }}
              />

            </Box>
            <Box>
              <DeckGL
                initialViewState={viewState}
                onClick={(info) => {
                  handleMapClick(info);
                }}
                controller
                layers={[pinLayer]}
              >
                <Map
                  mapboxAccessToken={MAPBOX_API_KEY}
                  mapStyle="mapbox://styles/mapbox/streets-v11"
                />
              </DeckGL>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: { xs: '20px', sm: '20px' },
          pt: { xs: '5px', sm: '5px' },
        }}
      >
        <Button className="confirm-btn" sx={{ fontSize: '18px' }} onClick={handleSelectLocation}>Select Location</Button>
        <Button className="cancel-btn" sx={{ fontSize: '18px', marginLeft: '0px', marginTop: '15px' }} onClick={() => { setShowRecoveryMap(false) }}>Cancel</Button>
      </DialogActions>
    </Dialog>
  </>
}

export default RecoveryMap;